import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";

import global from "../../../scss/dhp.scss";

import { Icon } from "../../ui/icon";

let style = Object.assign({}, global);

const CountdownToolbar = props => {
  const handleCountdownIconClick = () => {
    if (document.getElementById("editorBody").classList.contains("hide-secondAside")) props.toggle();
  };

  return (
    <li className={cx(style["toolset-group"])}>
      <div className={cx(style["toolset-item"], style["countdown-wrap"])}>
        <span
          className={cx(style["toolset-action"], style["custom-tooltip"])}
          id="countdown-toolbar"
          onClick={handleCountdownIconClick}>
          <Icon icon="ui-countdown" />

          <div className={cx(style["custom-tooltip-content"], style["top"])}>Update Countdown</div>
        </span>
      </div>
    </li>
  );
};
CountdownToolbar.propTypes = {
  toggle: PropTypes.func,
};

export default CountdownToolbar;
